module.exports = __webpack_public_path__ + "static/img/8.38ea902.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/sp/8.png
// module id = PIcs
// module chunks = 0